import React, { Component } from "react";
import Table from "./../common/table";
import { Link, withRouter } from "react-router-dom";

class TicketCategoriesTable extends Component {
	// constructor(props) {
	// 	super(props);
	// 	this.state = {
	// 		values: [],
	// 	};
	// }

	columns = [
		//   {path: '_id', label: 'Id'},
		{
			key: "checkbox",
			label: (
				<input
					type="checkbox"
					style={{
						width: "15px",
						height: "15px",
						marginTop: "0.4rem",
						borderRadius: 0,
					}}
					onChange={this.props.toggle}
				/>
			),
			content: (kanban) => (
				<span className="icon-img sm-r-5" style={{ marginTop: "15px" }}>
					<input
						type="checkbox"
						style={{
							width: "15px",
							height: "15px",
							marginTop: "0.4rem",
							borderRadius: 0,
						}}
						onChange={this.props.handleCheckboxChange}
						value={kanban._id}
						checked={this.props.checkedFields.includes(kanban._id)}
					/>
				</span>
			),
		},
		{
			key: "avatar",
			label: "Owner",
			content: (user) => (
				<span className="icon-img sm-r-5">
					<img
						style={{ width: "30px", height: "30px", borderRadius: "50%" }}
						src={user?.userID?.imageSrc}
						alt="userImg"
					/>
					<span> {user?.userID?.contactName?.first}</span>
				</span>
			),
		},
		/*{label: 'Owner',   path: 'user.contactName.first' } ,*/
		{label: 'BusinessName',   path: 'businessNo?.companyInfo?.businessName' } ,   
		{label: 'TicketCategory Name',   path: 'name' } ,   
		{label: 'locations',   path: 'locations' } ,   
		{label: 'department',   path: 'department' } ,   
		{
			key : "color" , 
			label: 'Color',
			path: 'color' ,
			content: (user) => {
				// Function to calculate luminance (brightness) of the color
				const getLuminance = (hex) => {
				  const rgb = parseInt(hex.slice(1), 16); // Convert hex to RGB
				  const r = (rgb >> 16) & 0xff;
				  const g = (rgb >>  8) & 0xff;
				  const b = (rgb >>  0) & 0xff;
			  
				  // Calculate luminance using the formula
				  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
				  return luminance;
				};
			  
				// Function to determine if text should be white or black
				const getTextColor = (hex) => {
				  const luminance = getLuminance(hex);
				  return luminance > 186 ? '#000' : '#fff'; // Dark background gets white text, light background gets black text
				};
			  
				return (
				  <div
					style={{
					  position: "relative",
					  width: "100%",
					  height: "40px",
					  border: "1px solid #ccc",
					  display: "flex",
					  justifyContent: "center",
					  alignItems: "center",
					  backgroundColor: user.color
					}}
				  >
					<span style={{ color: getTextColor(user.color), fontWeight: "bold" }}>
					  {user.color}
					</span>
				  </div>
				);
			  }
			  
		} , 
		// {label: 'Note',   path: 'note' } ,   	  	  
	];

	render() {
		//console.log(this.columns) ;
		const { ticketcategories, onSort, sortColumn } = this.props;
			console.log(ticketcategories);
		return (
			<Table
				columns={this.columns}
				sortColumn={sortColumn}
				onSort={onSort}
				data={ticketcategories}
			/>
		);
	}
}

export default TicketCategoriesTable;